module.exports = __webpack_public_path__ + "static/media/image2-2.e6d20a8b.jpg";